// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5a-2";
export var blackBorderOnHover = "_5a-7";
export var cell = "_5a-6";
export var cellContainer = "_5a-3";
export var checked = "_5a-8";
export var disabled = "_5a-5";
export var featuredIconCellContainer = "_5a-9";
export var featuredIconTextContainer = "_5a-b";
export var featuredIconWrapper = "_5a-a";
export var noBorder = "_5a-c";
export var orangeSelectedRow = "_da-3";
export var overflowableText = "_5a-0";
export var overflowableTextContainer = "_5a-1";
export var row = "_5f-0";
export var rowCheckboxCell = "_5a-4";
export var selectableTable = "_da-2";